import { render, staticRenderFns } from "./StaffAvatar.vue?vue&type=template&id=4dd88364&scoped=true&"
import script from "./StaffAvatar.vue?vue&type=script&lang=js&"
export * from "./StaffAvatar.vue?vue&type=script&lang=js&"
import style0 from "./StaffAvatar.vue?vue&type=style&index=0&id=4dd88364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd88364",
  null
  
)

export default component.exports